import { NotFound } from "@/components/NotFound";
import "@/router/staticData";
import { routeTree } from "@/routeTree.gen";
import { createRouter, type NotFoundRouteProps } from "@tanstack/react-router";
import { createElement } from "react";

const DefaultNotFound: (props: NotFoundRouteProps) => ReturnType<typeof createElement> = () => createElement(NotFound);

function parseSearch(searchStr: string): Record<string, unknown> {
  const params = new URLSearchParams(searchStr.startsWith("?") ? searchStr.slice(1) : searchStr);
  const search: Record<string, unknown> = {};

  params.forEach((value, key) => {
    const prev = search[key];
    if (prev == null) {
      search[key] = value;
      return;
    }
    if (Array.isArray(prev)) {
      prev.push(value);
      return;
    }
    search[key] = [prev, value];
  });

  return search;
}

function stringifySearch(search: Record<string, unknown>): string {
  const params = new URLSearchParams();

  Object.entries(search).forEach(([key, value]) => {
    if (value == null || value === "") return;

    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item != null && item !== "") {
          params.append(key, String(item));
        }
      });
      return;
    }

    params.set(key, String(value));
  });

  const query = params.toString();
  return query ? `?${query}` : "";
}

export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  defaultNotFoundComponent: DefaultNotFound,
  parseSearch,
  stringifySearch,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
